import dayjs, { Dayjs } from 'dayjs';
import { useMemo } from 'react';
import { useSubscription } from './useSubscription';

export const useTrial = () => {
  const { subscription } = useSubscription();
  const isTrialUser = useMemo<boolean>(
    () => !!subscription?.trial_ends_at && !!subscription?.is_on_trial,
    [subscription?.is_on_trial, subscription?.trial_ends_at],
  );

  const trialEndsAt = useMemo<Dayjs>(() => dayjs(subscription?.trial_ends_at), [subscription?.trial_ends_at]);

  return {
    isTrialUser,
    trialEndsAt,
    hasAvailableTrial: subscription?.has_available_trial,
  };
};
